import * as yup from 'yup';

export const validationSchema = yup.object({
  planId: yup
    .number()
    .moreThan(-1, 'Please select a plan.')
    .required('Please select a plan.'),
});
